export const GET_GROUP_TRANSACTION_START =
  'GET_GROUP_TRANSACTION_START';
export const GET_GROUP_TRANSACTION_SUCCESS =
  'GET_GROUP_TRANSACTION_SUCCESS';
export const GET_GROUP_TRANSACTION_ERROR =
  'GET_GROUP_TRANSACTION_ERROR';
